/**
 * Host-platform detection. CDK's `Platform` exposes browser engines but no
 * mac flag, and `RoutingService` only sniffs mobile user agents.
 */

/** True on macOS/iOS, where keyboard hints use ⌘ instead of Ctrl. */
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const uaData = (
    navigator as Navigator & { userAgentData?: { platform?: string } }
  ).userAgentData;
  const platform =
    uaData?.platform || navigator.platform || navigator.userAgent;
  return /mac|iphone|ipad|ipod/i.test(platform ?? '');
}
